import React, { useState } from "react";
import { Button, Container, Form, Input, Segment } from "semantic-ui-react";

const Login = ({ onLoginClicked }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div>
      <Container text>
        <h1>Login</h1>
        <Segment>
          <Form>
            <Form.Field>
              <label>
                Username
                <Input
                  placeholder="Username"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </label>
            </Form.Field>
            <Form.Field>
              <label>
                Password
                <Input
                  type="password"
                  placeholder="Password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </label>
            </Form.Field>
            <Button
              size="large"
              primary
              id="login"
              onClick={() => onLoginClicked(username, password)}
            >
              Login
            </Button>
          </Form>
        </Segment>
      </Container>
    </div>
  );
};

export default Login;
